export function wixcodePublicApi() {
  return {};
}
